module.exports = "<div class=\"row\">\n  <div class=\"col-md-4 justify-content-center\">\n    <app-home-sidebar></app-home-sidebar>\n  </div>\n  <div class=\"col-md-8\">\n      <div class=\"row\">\n        <div class=\"col\">\n            <ol class=\"breadcrumb\">\n                <li class=\"active\">Breadcrumb</li>\n            </ol>\n        </div>\n      </div>\n    <app-home-gallery></app-home-gallery>\n    <app-home-comments></app-home-comments>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main